import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '4rem',
      '& > div:first-child': {
        display: 'flex',
        '& > .MuiTypography-h1': {
          margin: 0,
          padding: '0.5rem 1.2rem 0.5rem 0',
          borderRight: '2px solid #000000',
        },

        '& > .MuiTypography-h3': {
          margin: 0,
          padding: '1rem 0 0.5rem 1.2rem',
          fontSize: '1.4rem',
        },
      },
    },
    wrapperCards: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gap: '2.5rem',
      marginBottom: '2.5rem',
    },
    wrapperCharts: {
      display: 'grid',
      gridTemplateColumns: '0.94fr 3fr',
      gap: '2.5rem',
      marginBottom: '2.5rem',
    },
  }),
)
